/**
 * Liberacao de funcionalidade — texto do aviso automatico.
 *
 * Esta e a UNICA copia da regra: o servidor grava o que o Master manda, sem
 * gerar texto proprio. O operador ve a previa do modal e pode editar antes de
 * liberar, entao o que vai para as empresas e exatamente o que ele viu.
 *
 * O corpo e MARKDOWN, como o de qualquer aviso: os quatro clientes renderizam
 * Markdown com HTML desligado, e HTML apareceria como texto cru.
 */
import { groupByModule } from '../../components/default/featureModules.js';
import { BROADCAST_BODY_MAX } from '../broadcast/broadcastEnums.js';
import { PLACEHOLDER_NAME } from '../broadcast/broadcastPlaceholders.js';

/** A API troca {nome} pelo primeiro nome de quem le; sem nome vira "Olá,". */
const GREETING = 'Olá ' + PLACEHOLDER_NAME + ',';

const OPENING = 'Sua empresa recebeu acesso temporário às funcionalidades abaixo. Aproveite para experimentar!';

/**
 * "yyyy-mm-dd" -> "dd/mm/yyyy" (ou "dd/mm"), por texto. Passar por
 * `new Date('2026-09-30')` daria meia-noite UTC, que no Brasil ainda e dia 29.
 */
export const formatDay = (isoDay, short) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDay || '');
  if (!match) return '';
  return short ? match[3] + '/' + match[2] : match[3] + '/' + match[2] + '/' + match[1];
};

/** Hoje no fuso do navegador, em yyyy-mm-dd. */
const today = () => {
  const now = new Date();
  const pad = (n) => (n < 10 ? '0' + n : '' + n);
  return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
};

export const broadcastTitle = (endsAt) => {
  const end = formatDay(endsAt, true);
  return end ? 'Novas funcionalidades liberadas até ' + end : 'Novas funcionalidades liberadas';
};

/** Nome de funcionalidade e texto, nao Markdown: um "*" nao pode virar italico. */
const escapeMarkdown = (text) => String(text || '').replace(/([\\`*_{}[\]()#+!|<>~])/g, '\\$1');

/** Funcionalidades escolhidas, na ordem da tela (modulo, depois funcionalidade). */
const selectedFeatures = (options, selected) =>
  groupByModule(options)
    .reduce((all, group) => all.concat(group.features), [])
    .filter((feature) => (selected || []).indexOf(feature.value) !== -1);

/**
 * Corpo do aviso: abertura, lista simples das funcionalidades (sem o modulo:
 * a empresa nao conhece essa categorizacao) na ordem da tela, e o periodo.
 *
 * Quando a lista inteira nao cabe no limite do editor de avisos, lista as que
 * cabem e fecha com "e mais N": o operador nao conseguiria salvar um texto
 * maior que o proprio editor aceita.
 *
 * `todayIso` e `max` existem para o teste; a tela usa os padroes.
 */
export const broadcastBody = (options, selected, startsAt, endsAt, todayIso, max) => {
  const limit = max || BROADCAST_BODY_MAX;
  const items = selectedFeatures(options, selected).map((feature) => '- ' + escapeMarkdown(feature.label));
  const period = 'Disponível de ' + formatDay(startsAt || todayIso || today()) +
    ' a ' + formatDay(endsAt) + '.';

  const compose = (lines) => [GREETING, '', OPENING, ''].concat(lines, ['', period]).join('\n');
  const remainder = (count) => '- e mais ' + count + (count === 1 ? ' funcionalidade' : ' funcionalidades');

  const text = compose(items);
  if (text.length <= limit) return text;

  for (let shown = items.length - 1; shown >= 0; shown--) {
    const shortened = compose(items.slice(0, shown).concat(remainder(items.length - shown)));
    if (shortened.length <= limit) return shortened;
  }
  return compose([remainder(items.length)]);
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/featureWindow/featureWindowBroadcast.js